import styled from 'styled-components/macro'

export const StyledExternalLink = styled.a<{
  $underline?: boolean
}>`
  text-decoration: none;
  font-weight: 500;
  width: content-fit;
  ${({ $underline }) => $underline && 'text-decoration: underline;'}
`
